import { createRequestSender } from '@bigcommerce/request-sender';

import BillingAddressRequestSender from './billing/billing-address-request-sender';
import { CheckoutRequestSender } from './checkout/checkout-request-sender';
import { PaymentRequestSender } from './payment/payment-request-sender';
import WalletButtonIntegrationService from './wallet-button-integration-service';

const createWalletButtonIntegrationService = (
    graphQLEndpoint: string,
): WalletButtonIntegrationService => {
    const requestSender = createRequestSender();

    return new WalletButtonIntegrationService(
        graphQLEndpoint,
        new BillingAddressRequestSender(requestSender),
        new PaymentRequestSender(requestSender),
        new CheckoutRequestSender(requestSender),
    );
};

export default createWalletButtonIntegrationService;
